import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SearchIcon from "@mui/icons-material/Search";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockIcon from "@mui/icons-material/Lock";
import InputIcon from "@mui/icons-material/Input";
import ArticleIcon from "@mui/icons-material/Article";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import CollectionsIcon from "@mui/icons-material/Collections";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import HistoryIcon from "@mui/icons-material/History";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import MapIcon from "@mui/icons-material/Map";
import { IconReceipt2 } from "@tabler/icons-react";
import NotesIcon from "@mui/icons-material/Notes";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CategoryIcon from "@mui/icons-material/Category";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import FlagIcon from "@mui/icons-material/Flag";
import ViewModuleIcon from "@mui/icons-material/ViewModule";

// Icon mapping object
const icons = {
  IconReceipt2,
  IconFAQ: HelpOutlineIcon,
  IconSettings: AdminPanelSettingsIcon,
  IconTemplate: ViewModuleIcon,
  IconWebStories: WebStoriesIcon,
  IconProcesso: DescriptionIcon,
  IconUser: PersonOutlineIcon,
  IconPermission: LockIcon,
  IconField: InputIcon,
  IconDocument: ArticleIcon,
  IconForm: ContentPasteIcon,
  IconGallery: CollectionsIcon,
  IconMedia: PermMediaIcon,
  IconMarketing: InfoOutlinedIcon,
  IconBackground: PhotoLibraryOutlinedIcon,
  IconLog: HistoryIcon,
  IconPayments: MonetizationOnIcon,
  IconMap: MapIcon,
  IconStringTemplate: NotesIcon,
  IconEmailContentTemplate: MarkEmailReadIcon,
  IconNewProcess: AddCircleOutlineIcon,
  IconAnalysis: ListAltIcon,
  IconCentral: HistoryIcon,
  IconSearch: SearchIcon,
  IconProjectType: CategoryIcon,
  IconIconFunction: VisibilityIcon,
  IconDbSync: CloudSyncIcon,
  IconFlow: AccountTreeIcon,
  IconStatus: FlagIcon,
  IconTasks: FormatListBulletedIcon,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const basePages = [
  {
    id: "gixMap",
    title: "GeoGix",
    type: "item",
    icon: icons.IconMap,
    url: "/mapa",
    breadcrumbs: false,
  },
  // {
  //   id: "Process",
  //   title: "Processos",
  //   type: "item",
  //   icon: icons.IconProcesso,
  //   url: "/process-list",
  //   breadcrumbs: false,
  // },
  {
    id: "ProjectDynamicNew",
    title: "Processo (Novo)",
    type: "item",
    icon: icons.IconNewProcess,
    url: "/project/dynamic_new",
    breadcrumbs: false,
  },
  {
    id: "ProjectDynamicList",
    title: "Análise",
    type: "item",
    icon: icons.IconAnalysis,
    url: "/project/dynamic_list",
    breadcrumbs: false,
  },
  {
    id: "UserList",
    title: "Usuários",
    type: "item",
    icon: icons.IconUser,
    url: "/user-list",
    breadcrumbs: false,
  },
  {
    id: "Payments",
    title: "Recebimentos",
    type: "item",
    icon: icons.IconPayments,
    url: "/payment",
    breadcrumbs: false,
  },
  {
    id: "DocumentGallery",
    title: "Galeria de Anexos",
    type: "item",
    icon: icons.IconGallery,
    url: "/document/galery",
    breadcrumbs: false,
  },
];

const adminPages = [
  {
    id: "ProjectSearch",
    title: "Busca Geral",
    type: "item",
    icon: icons.IconSearch,
    url: "/project/search",
    breadcrumbs: false,
  },
  {
    id: "Permission",
    title: "Permissões",
    type: "item",
    icon: icons.IconPermission,
    url: "/permission",
    breadcrumbs: false,
  },
  {
    id: "Form",
    title: "Formulários",
    type: "item",
    icon: icons.IconForm,
    url: "/form",
    breadcrumbs: false,
  },
  {
    id: "Field",
    title: "Campos",
    type: "item",
    icon: icons.IconField,
    url: "/field",
    breadcrumbs: false,
  },
  {
    id: "Document",
    title: "Documentos",
    type: "item",
    icon: icons.IconDocument,
    url: "/documents",
    breadcrumbs: false,
  },
  {
    id: "Marketing",
    title: "Marketing",
    type: "item",
    icon: icons.IconMarketing,
    url: "/marketing",
    breadcrumbs: false,
  },
  {
    id: "Background",
    title: "Plano de Fundo",
    type: "item",
    icon: icons.IconBackground,
    url: "/background",
    breadcrumbs: false,
  },
  {
    id: "Setup",
    title: "Configuração",
    type: "item",
    icon: icons.IconSettings,
    url: "/setup",
    breadcrumbs: false,
  },
  {
    id: "Template",
    title: "Template",
    type: "item",
    icon: icons.IconTemplate,
    url: "/template_settings",
    breadcrumbs: false,
  },
  {
    id: "StringTemplates",
    title: "Texto Dinâmico",
    type: "item",
    icon: icons.IconStringTemplate,
    url: "/string_templates",
    breadcrumbs: false,
  },
  {
    id: "EmailContentTemplates",
    title: "Conteúdo de Email",
    type: "item",
    icon: icons.IconEmailContentTemplate,
    url: "/email_content_templates",
    breadcrumbs: false,
  },
  {
    id: "IconFunctions",
    title: "Função",
    type: "item",
    icon: icons.IconIconFunction,
    url: "/icon_functions",
    breadcrumbs: false,
  },
  {
    id: "DbSync",
    title: "Sincronizar Banco",
    type: "item",
    icon: icons.IconDbSync,
    url: "/db_sync",
    breadcrumbs: false,
  },
  {
    id: "ProjectCentral",
    title: "Central",
    type: "item",
    icon: icons.IconCentral,
    url: "/project/central",
    breadcrumbs: false,
  },
  {
    id: "ProjectTypes",
    title: "Tipo de Processo",
    type: "item",
    icon: icons.IconProjectType,
    url: "/project_types",
    breadcrumbs: false,
  },
  {
    id: "Status",
    title: "Status",
    type: "item",
    icon: icons.IconStatus,
    url: "/status",
    breadcrumbs: false,
  },
  {
    id: "Flow",
    title: "Fluxo",
    type: "item",
    icon: icons.IconFlow,
    url: "/flow",
    breadcrumbs: false,
  },
  {
    id: "TaskTypes",
    title: "Tipos de Tarefa",
    type: "item",
    icon: icons.IconTasks, // precisa importar algum ícone, ex: FormatListBulletedIcon
    url: "/task_types",
    breadcrumbs: false,
  },
];

export const getPages = (isAdmin = false) => {
  const children = isAdmin ? [...basePages, ...adminPages] : basePages;
  
  return {
    id: "pages",
    type: "group",
    children: children,
  };
};

// Default export for backward compatibility
const pages = getPages(false);

export default pages;
